import {http} from "./http";
import { getPaginationRequestParams } from "../utils/paginationRequest";

export function getUsers (pagination) {
    return http.get(`v1/users?${getPaginationRequestParams(pagination)}`);
}

export function deleteUser (id) {
    return http.delete(`v1/users/${id}`);
}

export function createUser (user) {
    return http.post(`v1/users`, {...user});
}

export function updateUser (user, id) {
    return http.patch(`v1/users/${id}`, {...user});
}

export function getUser (id) {
    return http.get(`v1/users/${id}`);
}

export function exportToXlsx() {
    return http.post(`/v1/users/export-users`, undefined, {
        responseType: "blob", 
    });
}

export const mappedUserRole = [
    { value: "ADMIN", label: "Amministratore" },
    { value: "SUBSCRIBER", label: "Amministratore" },
    { value: "GROUP_MANAGER", label: "Amministratore" },
];